// src/app/features/warehouse/store/warehouse.selectors.ts

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WarehouseState } from './warehouse.state';

export const WAREHOUSE_FEATURE_KEY = 'warehouse';

export const selectWarehouseState = createFeatureSelector<WarehouseState>(WAREHOUSE_FEATURE_KEY);

// ── Invoices ──────────────────────────────────────────────────────────────────

export const selectInvoices        = createSelector(selectWarehouseState, s => s.invoices);
export const selectInvoicesData    = createSelector(selectInvoices, s => s.data);
export const selectInvoicesItems   = createSelector(selectInvoices, s => s.data?.items ?? []);
export const selectInvoicesTotal   = createSelector(selectInvoices, s => s.data?.totalCount ?? 0);
export const selectInvoicesLoading = createSelector(selectInvoices, s => s.loading);
export const selectInvoicesError   = createSelector(selectInvoices, s => s.error);

// ── Invoice Detail ────────────────────────────────────────────────────────────

export const selectInvoiceDetailMap = createSelector(selectWarehouseState, s => s.invoiceDetail);
export const selectInvoiceDetail    = (id: number) =>
  createSelector(selectInvoiceDetailMap, m => m[id] ?? null);

// ── Articles ──────────────────────────────────────────────────────────────────

export const selectArticles        = createSelector(selectWarehouseState, s => s.articles);
export const selectArticlesData    = createSelector(selectArticles, s => s.data);
export const selectArticlesItems   = createSelector(selectArticles, s => s.data?.items ?? []);
export const selectArticlesTotal   = createSelector(selectArticles, s => s.data?.totalCount ?? 0);
export const selectArticlesLoading = createSelector(selectArticles, s => s.loading);
export const selectArticlesError   = createSelector(selectArticles, s => s.error);

// ── Article Types ─────────────────────────────────────────────────────────────

export const selectArticleTypes        = createSelector(selectWarehouseState, s => s.articleTypes);
export const selectArticleTypesData    = createSelector(selectArticleTypes, s => s.data);
export const selectArticleTypesItems   = createSelector(selectArticleTypes, s => s.data?.items ?? []);
export const selectArticleTypesTotal   = createSelector(selectArticleTypes, s => s.data?.totalCount ?? 0);
export const selectArticleTypesLoading = createSelector(selectArticleTypes, s => s.loading);
export const selectArticleTypesError   = createSelector(selectArticleTypes, s => s.error);

// ── Stock ─────────────────────────────────────────────────────────────────────

export const selectStock        = createSelector(selectWarehouseState, s => s.stock);
export const selectStockData    = createSelector(selectStock, s => s.data);
export const selectStockItems   = createSelector(selectStock, s => s.data?.items ?? []);
export const selectStockTotal   = createSelector(selectStock, s => s.data?.totalCount ?? 0);
export const selectStockLoading = createSelector(selectStock, s => s.loading);
export const selectStockError   = createSelector(selectStock, s => s.error);

// ── Stock Movements ───────────────────────────────────────────────────────────

export const selectStockMovementsMap = createSelector(selectWarehouseState, s => s.stockMovements);
export const selectStockMovements    = (artId: number) =>
  createSelector(selectStockMovementsMap, m => m[artId] ?? null);

// ── Low Stock ─────────────────────────────────────────────────────────────────

export const selectLowStock        = createSelector(selectWarehouseState, s => s.lowStock);
export const selectLowStockData    = createSelector(selectLowStock, s => s.data);
export const selectLowStockItems   = createSelector(selectLowStock, s => s.data?.items ?? []);
export const selectLowStockTotal   = createSelector(selectLowStock, s => s.data?.totalCount ?? 0);
export const selectLowStockLoading = createSelector(selectLowStock, s => s.loading);
export const selectLowStockError   = createSelector(selectLowStock, s => s.error);

// ── Komitents ─────────────────────────────────────────────────────────────────

export const selectKomitents        = createSelector(selectWarehouseState, s => s.komitents);
export const selectKomitentsData    = createSelector(selectKomitents, s => s.data);
export const selectKomitentsItems   = createSelector(selectKomitents, s => s.data?.items ?? []);
export const selectKomitentsTotal   = createSelector(selectKomitents, s => s.data?.totalCount ?? 0);
export const selectKomitentsLoading = createSelector(selectKomitents, s => s.loading);
export const selectKomitentsError   = createSelector(selectKomitents, s => s.error);

// ── Komitent Detail ───────────────────────────────────────────────────────────

export const selectKomitentDetailMap = createSelector(selectWarehouseState, s => s.komitentDetail);
export const selectKomitentDetail    = (id: number) =>
  createSelector(selectKomitentDetailMap, m => m[id] ?? null);

// ── Summary ───────────────────────────────────────────────────────────────────

export const selectSummary        = createSelector(selectWarehouseState, s => s.summary);
export const selectSummaryData    = createSelector(selectSummary, s => s.data);
export const selectSummaryLoading = createSelector(selectSummary, s => s.loading);
export const selectSummaryError   = createSelector(selectSummary, s => s.error);
